module.exports = "static/assets/5796214a21c5c1727ed7b08096ee7cff.woff2";